import { render, staticRenderFns } from "./DealSmall.vue?vue&type=template&id=2af590f8&scoped=true&"
import script from "./DealSmall.vue?vue&type=script&lang=js&"
export * from "./DealSmall.vue?vue&type=script&lang=js&"
import style0 from "./DealSmall.vue?vue&type=style&index=0&id=2af590f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af590f8",
  null
  
)

export default component.exports